import React, { useEffect, useState } from "react";
import api, { formatApiError } from "../../lib/api";
import { Window, EmptyState, Loading } from "../../components/VB";
import { toast } from "sonner";
import { Bell, Send, CheckCircle2 } from "lucide-react";

// Menu "Notifikasi" — timeline pengajuan revisi (dikirim / disetujui admin) untuk akun Group
// Client. Membuka halaman ini otomatis menandai semua notifikasi sebagai sudah dibaca (badge
// angka di sidebar hilang begitu Layout re-fetch unread-count pada navigasi berikutnya).
export default function ClientNotifikasi() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const { data } = await api.get("/client/notifications");
        setItems(data);
        // Best-effort: menandai semua terbaca begitu halaman ini dibuka.
        api.post("/client/notifications/read-all").catch(() => {});
      } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
      setLoading(false);
    })();
  }, []);

  const iconFor = (type) => (type === "revision_approved" ? <CheckCircle2 className="w-4 h-4" style={{ color: "#4f8a10" }} /> : <Send className="w-4 h-4" style={{ color: "#003399" }} />);

  return (
    <Window title={<><Bell className="w-4 h-4 inline mr-1" />Notifikasi</>}>
      <div style={{ fontSize: 12, color: "#666", marginBottom: 10 }}>
        Riwayat pengajuan revisi project — status pengiriman &amp; persetujuan dari admin.
      </div>
      {loading ? <Loading /> : items.length === 0 ? (
        <EmptyState message="Belum ada notifikasi" />
      ) : (
        <div style={{ display: "grid", gap: 6 }}>
          {items.map((n) => (
            <div
              key={n.id}
              style={{
                display: "flex", alignItems: "flex-start", gap: 10, padding: 10,
                background: n.is_read ? "#fafafa" : "#eef4ff",
                border: "1px solid " + (n.is_read ? "#ddd" : "#b0c8f0"),
              }}
              data-testid={`notif-${n.id}`}
            >
              <div style={{ marginTop: 2 }}>{iconFor(n.type)}</div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 12 }}>{n.message}</div>
                <div style={{ fontSize: 10, color: "#888", marginTop: 2 }}>
                  {n.created_at ? new Date(n.created_at).toLocaleString("id-ID") : ""}
                </div>
              </div>
              {!n.is_read && (
                <span style={{ width: 8, height: 8, borderRadius: 8, background: "#d8000c", marginTop: 4, flexShrink: 0 }} title="Belum dibaca" />
              )}
            </div>
          ))}
        </div>
      )}
    </Window>
  );
}
